import { Producto, Productos } from '@/interface/producto.model';
import { FechaFunctionsService } from '@/utils/functions.service';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

export interface ListaArqueo {
  movimiento: string;
  id_pedido: string;
  numero_pedido?: number | string | null;
  numero_pedido_format?: string;
  tipopago: string;
  fecha_movimiento: any;
  hora_movimiento: string;
  ingreso: number;
  egreso: number;
  acumulativeTotal?: number;
  motivo: string;
}

@Component({
  selector: 'app-lista-arqueo',
  templateUrl: './lista-arqueo.component.html',
  styleUrls: ['./lista-arqueo.component.scss']
})
export class ListaArqueoComponent {
  @Input() label: string = "Todos los pedidos";
  @Input() rows: Array<ListaArqueo> = [];
  @Input() tempRows: Array<any>;
  @Input() isLoading: boolean = false;
  @Input() mini: boolean = false;
  @Input() onlyMedioPago: boolean = false;
  @Input() showCliente: boolean = true;
  @Input() showHeader: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() sortByKey: string = 'fecha_termino';
  @Input() reverseSort: boolean = true;
  @Output() updateData = new EventEmitter();
  @Output() updateDataMedioPago = new EventEmitter();
  @ViewChild('table') table: DatatableComponent;
  nowDay: string = this.Func.NowDay();
  nextDay: string = this.Func.NextDay();
  messages: any;
  itemsPerPage: number = 50;
  page: number = 1;
  estados: Array<any>;

  constructor(private router: Router,
    public generalService: GeneralService,
    private toastr: ToastrService,
    public Func: FechaFunctionsService,
    public loadingService: LoadingService) {
  }

  async ngOnInit() {
    await this.getData()
  }


  async getData() {
    try {
      this.loadingService.setLoading(true);
      let queryParam: string = "?fecha_pago=" + this.Func.NowDay();
      let res = await this.generalService.getListar(`arqueo/listado${queryParam}`)
      this.rows = res.data.map(row => ({
        movimiento: row.movimiento,
        id_pedido: row.id_pedido,
        numero_pedido: row.numero_pedido,
        numero_pedido_format: row.numero_pedido_format,
        tipopago: row.tipopago,
        fecha_movimiento: row.fecha_movimiento,
        hora_movimiento: row.hora_movimiento,
        ingreso: row.ingreso,
        egreso: row.egreso,
        motivo: row.motivo
      }));
      this.calculateCumulativeTotals();
      this.loadingService.setLoading(false);
    } catch (error) {
      console.log(error)
      this.loadingService.setLoading(false);
    }
  }

  calculateCumulativeTotals() {
    let cumulativeSum = 0;

    this.rows.forEach(row => {
      cumulativeSum += row.ingreso - row.egreso;
      row.acumulativeTotal = cumulativeSum;
    });
  }

  getColumnTotal(columnName): number {
    return this.rows?.reduce((total, row) => total + row[columnName], 0);
  }

  getCumulativeTotal(): number {
    return this.rows.length > 0 ? this.rows[this.rows.length - 1].acumulativeTotal! : 0;
  }

}
